import { render, staticRenderFns } from "./collect-progress-overview.vue?vue&type=template&id=54ebfca6&"
import script from "./collect-progress-overview.vue?vue&type=script&lang=ts&"
export * from "./collect-progress-overview.vue?vue&type=script&lang=ts&"
import style0 from "./collect-progress-overview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports